<template>
<layout-content>
  <template #toolbar>
  </template>

  <template #body>
    <data-wrapper>
      <el-table
        ref="table"
        :data="list"
        height="100%"
        border
        stripe
        highlight-current-row
        header-row-class-name="custom-table-header"
        class="custom-table no-inner-border"
        style="width: 100%"
        @row-click="onOpenEditor"
      >
        <el-table-column label="序号" width="50">
          <template slot-scope="{$index}">{{$index + 1}}</template>
        </el-table-column>

        <el-table-column label="是否启用" align="center" width="80">
          <template slot-scope="{row}">
            <my-switch
              v-model="row.status"
              @click.native.stop
              @change="onChangeStatus(row, ...arguments)"
            />
          </template>
        </el-table-column>

        <el-table-column prop="name" label="规则名称"  width="150" />

        <el-table-column prop="description" label="规则描述">
          <template slot-scope="{row}">
            <section v-html="row.explanation"></section>
          </template>
        </el-table-column>
      </el-table>
    </data-wrapper>
  </template>

  <template #editor>
    <editor
      ref="editor"
      @save="getList"
      @close="onCancelHighlightTableRow"
    />
  </template>
</layout-content>
</template>

<script>
import BaseListEditor from '../../../BaseListEditor'
import Editor from './Editor'
import DataWrapper from '../../../../components/Data/DataWrapper'

export default {
  name: 'SystemSettingsQCAuditRule',
  routeInfo: {
    label: '质控机审规则',
    icon: 'fa fa-list-ul',
    curdInfo: {
      api: 'AuditConfig',
      id: 'id',
      name: 'name',
      editName: '质控机审规则'
    }
  },
  extends: BaseListEditor,
  components: {DataWrapper, Editor},
  data () {
    return {
      list: []
    }
  },
  computed: {
  },
  methods: {
    getList () {
      this.$api.AuditConfig.getList().then(auditRule => {
        this.list = auditRule
      }).catch(console.error)
    }
  },
  created () {
    this.getList()
  },
  beforeDestroy () {
  }
}
</script>

<style lang="scss" scoped>
.auto-audit-rule-wrapper {
  $SIDE-BAR-WIDTH: 210px;

  position: relative;
  width: 100%;
  height: 100%;
  padding-left: calc(210px + .8em);

  > .audit-rule-category-sidebar-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 210px;
    height: 100%;
  }

  > .auto-audit-rule-list-editor {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/04Config/06QC-Audit-Rule/index.vue